export default "__VITE_ASSET__60z4mtwl__"